import { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import image_01 from '../../img/TradeTerminal/Features/image_01.png';
import image_02 from '../../img/TradeTerminal/Features/image_02.png';
import image_03 from '../../img/TradeTerminal/Features/image_03.png';
import image_04 from '../../img/TradeTerminal/Features/image_04.png';
import image_05 from '../../img/TradeTerminal/Features/image_05.png';
import image_06 from '../../img/TradeTerminal/Features/image_06.png';
import arrow_left from '../../img/TradeTerminal/Features/arrow_left.svg';
import arrow_right from '../../img/TradeTerminal/Features/arrow_right.svg';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Grid } from "swiper/modules";
import "swiper/css";
import 'swiper/css/grid';

const cards = [
    {
        image: image_01,
        subtitle: 'terminal.features.card_01.subtitle',
        text: 'terminal.features.card_01.text',
    },
    {
        image: image_02,
        subtitle: 'terminal.features.card_02.subtitle',
        text: 'terminal.features.card_02.text',
    },
    {
        image: image_03,
        subtitle: 'terminal.features.card_03.subtitle',
        text: 'terminal.features.card_03.text',
    },
    {
        image: image_04,
        subtitle: 'terminal.features.card_04.subtitle',
        text: 'terminal.features.card_04.text',
    },
    {
        image: image_05,
        subtitle: 'terminal.features.card_05.subtitle',
        text: 'terminal.features.card_05.text',
    },
    {
        image: image_06,
        subtitle: 'terminal.features.card_06.subtitle',
        text: 'terminal.features.card_06.text',
    },
];

const Features = () => {
    const { t } = useTranslation();
    // eslint-disable-next-line
    const [swiper, setSwiper] = useState({});
    const swiperRef = useRef(null);
    return (
        <section className="open-sans relative pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative">
                <h2 className="text-[#0C2780] font-[700] text-[28px] xl:text-[45px] text-center">
                    {t('terminal.features.title')}
                </h2>
                <div className="lg:mt-[60px] md:mt-[40px] mt-[20px]">
                    <div className="sm:hidden flex content-end justify-end sm:mt-[25px] mt-[15px] mb-[12px] gap-[20px]">
                        <div className="w-[36px] cursor-pointer hover:opacity-70 duration-150" onClick={() => swiperRef.current.swiper.slidePrev()}>
                            <img src={arrow_left} alt='' />
                        </div>
                        <div className="w-[36px] cursor-pointer hover:opacity-70 duration-150" onClick={() => swiperRef.current.swiper.slideNext()}>
                            <img src={arrow_right} alt='' />
                        </div>
                    </div>
                    <Swiper
                        ref={swiperRef}
                        modules={[Grid, Navigation]}
                        className=""
                        style={{ overflow: 'visible' }}
                        grabCursor
                        pagination
                        spaceBetween={20}
                        slidesPerView={1}
                        grid={{
                            rows: 1,
                            fill: "row",
                        }}
                        onInit={(e) => { setSwiper(e) }}
                        breakpoints={{
                            900: {
                                slidesPerView: 2,
                                spaceBetween: 0,
                                grid: {
                                    rows: 3,
                                    fill: "row",
                                }
                            },
                            640: {
                                slidesPerView: 2,
                                spaceBetween: 0,
                                grid: {
                                    rows: 3,
                                    fill: "row",
                                }
                            },
                        }}
                    >
                        {cards.map((card, index) =>
                            <SwiperSlide className="!h-auto" key={index}>
                                <div className="sm:p-[20px] sm:pb-[40px] sm:border-[1px] sm:border-[#00000020] h-[100%]">
                                    <img className="w-full" src={card.image} alt='' />
                                    <h4 className="mt-[20px] mb-[15px] sm:text-[16px] font-[700] text-[14px] text-[#0C2780]">
                                        {t(card.subtitle)}
                                    </h4>
                                    <p className="sm:text-[16px] font-[300] text-[14px] text-[#0C2780]">
                                        {t(card.text)}
                                    </p>
                                </div>
                            </SwiperSlide>
                        )}
                    </Swiper>
                </div>
            </div>
        </section>
    )
};

export default Features;
